import Swiper from 'swiper';

$(document).on('recommended_swiper_trigger', '.recommendations-container', function() {
    $('.slider-collection-4-wrapper').not('.slick-initialized').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false
            }
            }
        ]
    });
});